<template>
<b-overlay opacity="0.75" spinner-variant="primary" :show="$root.$data.bsLoader">
    <div class="body-wrapper">
        <nav-bar />

        <div class="compilance-wrapper">
            <div class="container-fluid">

                <div class="row">
                    <div class="col-md-7 col-lg-8 col-xl-9">
                        <ContractorDetails></ContractorDetails>
                        <JobHistory></JobHistory>
                        <b-row>
                            <b-col md="12" class="d-none d-md-block" style="margin-top: 9rem; margin-bottom: 1rem;">
                                <footer-component></footer-component>
                            </b-col>
                        </b-row>
                    </div>

                    <div class="col-md-5 col-lg-4 col-xl-3" style="padding:1px;">
                        <AbnAcn v-if="subPage == 'abn_acn'" />
                        <Licence v-if="subPage == 'license'" />
                        <Insurance v-if="subPage == 'insurance'" />
                        <ContractorDocuments v-if="!subPage" />
                    </div>

                </div>
                        <b-row>
                            <b-col md="12" class="d-block d-md-none mt-0">
                                <footer-component></footer-component>
                            </b-col>
                        </b-row>


            </div>


        </div>
    </div>
</b-overlay>
</template>

<script>
import NavBar from "@frontend/pages/contractor/includes/NavBar.vue";
import JobHistory from '@frontend/pages/contractor/compliance/JobHistory.vue';
import ContractorDetails from '@frontend/pages/contractor/compliance/ContractorDetails.vue';
import ContractorDocuments from '@frontend/pages/contractor/compliance/contractor-documents/Index.vue';
import AbnAcn from '@frontend/pages/contractor/compliance/abn-acn/Index.vue';
import Licence from '@frontend/pages/contractor/compliance/licence/Index.vue';
import Insurance from '@frontend/pages/contractor/compliance/insurance/Index.vue';
import FooterComponent from "../../includes/FooterComponent.vue";

export default {
    props: {
        subPage: String,
    },
    components: {
        NavBar,
        JobHistory,
        ContractorDetails,
        ContractorDocuments,
        AbnAcn,
        Licence,
        Insurance,
        FooterComponent
    }
};
</script>

<style scoped>
    .compilance-wrapper{
        background-color: #ffffff;
    }
    .side-wrapper{
        background-color: #eff0f6;
    }


</style>
